
<v-form ref="form" v-if="entry">
    <v-card flat>
        <div class="v-flex" v-if="isReminder">
            <f-date-picker
                v-model = "time"
                label   = "Zeit"
                :time   = "true"
                class   = "mr-2"
                :rules  = "[rules.required]"
            />
            <v-select
                v-model    = "entry.frequency"
                class      = "crm-reminder-frequency ml-2"
                item-value = "id"
                item-text  = "name"
                :items     = "frequency"
                label      = "Frequenz"
            />
        </div>

        <v-text-field
            v-if    = "!isPostponement && !isClipboard && !isDocument"
            v-model = "entry.subject"
            label   = "Thema"
            :rules  = "[rules.required]"
        />

        <f-read-only-field
            label  ="Thema"
            :value = "$t(entry.subject)"
            filled
        />

        <v-row class="no-frame mt-2" v-if="isPostponement">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    :label = "$t('inc.assessment.postponment.currentDate')"
                    :value ="dateScheduled"
                    color  = "primary white--text space pl-1"
                    dense
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-read-only-field
                    :label = "$t('inc.assessment.postponment.newDate')"
                    :value ="dateScheduledNew"
                    color = "primary white--text space pl-1"
                    dense
                />
            </v-col>
        </v-row>
        <v-row class="no-frame mt-5" v-if="isPostponement">
            <v-col class="no-frame pr-2">
                <f-enum-select
                    v-model   = "entry.postponement"
                    :label    = "$t('inc.assessment.postponment.reason')"
                    module    = "inc"
                    type      = "postponmentType"
                    :rules  = "[rules.required]"
                />
            </v-col>
            <v-col class="no-frame pr-2">
                <f-date-picker
                    label   = "inc.assessment.postponment.received"
                    v-model = "entry.time"
                    :time   = "true"
                    :rules  = "[rules.required]"
                />
            </v-col>
        </v-row>

        <v-textarea
            v-model        = "entry.description"
            rows           = "5"
            class          ="crm-textarea mt-3"
            label          = "Notiz"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            hide-details   = "true"
            flat
            no-resize
        />

        <crm-edit-partner
            v-if    = "showPartner"
            v-model = "entry.partner"
            class   =  "mt-4"
            :label  = "isPostponement ? 'Gemeldet von' : 'Gesprächspartner'"
        />
    </v-card>
</v-form>
